import styled, { css } from 'styled-components';

export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  ${props => props.isFav && css`
    flex-direction: row !important;
    justify-content: space-around;
  `};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin-left: 0;
    flex-direction: column;
  };
`;

export const ResultLabel = styled.div`
  color: ${props => props.theme.colors[props.color]};
  font-size: 18px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    font-size: 16px;
  };
  margin: auto;
  ${props => (props.font) && css` 
    font-family: ${props.theme.fontSets[props.font]};
  `};
  margin-right: 1.5em;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin: 0.4em 0; 
  }
`;
